import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const getDevicesAddedByDate = createAsyncThunk(
	'csReports/getDevicesAddedByDate',
	async (params: {
	  startDate: string;
	  endDate: string;
	}) => {
	  console.log('getDevicesAddedByDate params', params);

	  const response = await api.get(
	  `cs_reports/newDevices?startDate=${params.startDate}&endDate=${params.endDate}`,
	  {
		timeout: 30000,
	  });
	  console.log('getDevicesAddedByDate response', response.data);
	  return response.data;
	}
);

// report1 -> Devices added to Account By Date
const initialState: {
    status: string;
    error: string;
    report1: any;
} = {
    status: '',
    error: '',
    report1: {},
};

const csReportsSlice = createSlice({
    name: 'csReports',
    initialState: initialState,
    reducers: {
        csReportsSliceClean(state, action) {
          console.log('csReportsSliceClean', action);
          state.report1.loading = false;
          state.report1.complete = false;
          state.report1.error = '';
      },
    },
    extraReducers: (builder) => {
      //getClass
      builder.addCase(getDevicesAddedByDate.pending, (state) => {
          state.report1.loading = true;
          state.report1.complete = false;
          state.report1.error = '';
        });
        builder.addCase(getDevicesAddedByDate.fulfilled, (state, action) => {
          state.report1.loading = false;
          state.report1.complete = true;
          state.report1.devices =  action.payload;
        });
        builder.addCase(getDevicesAddedByDate.rejected, (state, action) => {
          state.report1.loading = false;
          state.report1.complete = false;
          state.report1 = Object.assign(state.report1, action.payload);
          state.report1.error = action.error ? action.error.message! : '';
        });
          
    },
  });
  
  export const { csReportsSliceClean } = csReportsSlice.actions;
  export default csReportsSlice;